
import * as React from "react"
import { cn } from "@/lib/utils"

const SidebarContent = ({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <div className={cn("flex-1 overflow-y-auto py-2", className)} {...props}>
      {children}
    </div>
  )
}
SidebarContent.displayName = "SidebarContent"

export { SidebarContent }
